<template>
    <div :class="['hle-history-page', { 'hle-history-page--deluxe': isDeluxeLayout }]">
        <BreadcrumbsProject
        v-if="!isDeluxeLayout"
        :breadcrumbs="[
             {
                link : '/high-level-estimates',
                title : $t('Bidding'),
                isRouterLink: true
            },
            {
                link : '/high-level-estimates/' + hleProjectId + '/bill-of-quantities',
                title : (hleProject.projectName || '-' )+ ' - ' + $t('Bidding Module.Detailed Estimates'),
                isRouterLink: true
            },
            {
                link : '/high-level-estimates/' + hleProjectId + '/bill-of-quantities/' + boqId + '/history',
                title :boqUrlname + ' - ' + $t('History'),
                isRouterLink: true
            },
        ]"
        />
        <router-link
            v-if="isDeluxeLayout"
            :to="{ name: 'HleBoqs', params: { id: hleProjectId } }"
            class="hle-history-back"
        >
            <i class="fa-solid fa-chevron-left"></i>
            {{ $t('Back') }} {{ $t('Bidding Module.Detailed Estimates') }}
        </router-link>

        <div class="hle-history-revision-nav" aria-label="Revision navigation">
            <button
                type="button"
                class="hle-history-revision-btn"
                :class="{ 'hle-history-revision-btn--hidden': currentIndex == 0 }"
                :disabled="currentIndex == 0"
                :aria-label="$t('Previous')"
                @click="ChangeMinusIndex"
            >
                <i class="fa-solid fa-arrow-left-long"></i>
            </button>
            <div class="hle-history-revision-title">
                <span>{{ $t('History') }}</span>
                <h4>{{ $t('Revision') }} {{ currentIndex }}</h4>
                <small v-if="revisionList.length">{{ currentIndex + 1 }} / {{ revisionList.length }}</small>
            </div>
            <button
                type="button"
                class="hle-history-revision-btn"
                :class="{ 'hle-history-revision-btn--hidden': currentIndex >= revisionList.length - 1 }"
                :disabled="currentIndex >= revisionList.length - 1"
                :aria-label="$t('Next')"
                @click="ChangeAddIndex"
            >
                <i class="fa-solid fa-arrow-right-long"></i>
            </button>
        </div>

        <div class="card hle-bidding-card hle-boq-builder-card hle-history-card">
            <div class="card-header bg-white hle-boq-builder-card__header hle-history-card__header">
                <div class="hle-history-card__heading">
                    <div class="hle-boq-builder-title">
                        <span class="hle-estimate-eyebrow">{{ $t('Bidding Module.Detailed Estimate') }} {{ $t('History') }}</span>
                        <router-link
                            :to="{ name: 'HleBoQBuilder', params: { id: hleProjectId, boqId: boqItem._id } }"
                            class="hle-history-card__title text-capitalize"
                        >
                            {{ boqItem.name || '-' }}
                        </router-link>
                    </div>
                    <div class="hle-history-currency">
                        <span>{{ $t('Currency') }}</span>
                        <strong>{{ boqItem.currencyId.sign || '-' }} {{ boqItem.currencyId.name || '-' }}</strong>
                    </div>
                </div>
            </div>
            <div class="card-body hle-boq-builder-card__body hle-history-card__body">
                <FigureCurrencyNote :currency="boqItem.currencyId" />
                <div class="hle-boq-builder-table-wrap hle-history-table-wrap">
                    <BoqSectionTableReadOnly
                        v-if="boqItem"
                        :rawSections="rawSections"
                        :boqItem="boqItem"
                        :breakdownLink="breakdownLink"
                    />
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import BreadcrumbsProject  from '@/components/projectInformation/BreadcrumbsProject.vue'
import {GetHighLevelBoq, GetHighLevelProject,GetHleNewBoqCreatorSectionsRevisions} from '@/actions/boqActions.js' 
import {ReformatDate} from '@/helpers/utilities.js'
import { LinkList} from '@/helpers/utilities.js'
import {mapActions} from 'vuex'
import BoqSectionTableReadOnly  from '@/components/boq/BoqSectionTableReadOnly.vue'
import FigureCurrencyNote from '@/components/layout/FigureCurrencyNote.vue'
export default {
    name : 'HleBoqItemsHistory',
    components : {
        BreadcrumbsProject, BoqSectionTableReadOnly, FigureCurrencyNote
    },
    computed : {
        isDeluxeLayout(){
            return this.$route.meta.layout === 'deluxe'
        }
    },
    methods : {
        ...mapActions(['ChangeActiveLink']),
        async ChangeAddIndex(){
            const self = this
            self.boqListParams.skip = 0
            self.boqListParams.id = self.revisionList[++this.currentIndex]._id
            self.rawSections = await GetHleNewBoqCreatorSectionsRevisions(self.boqId,self.boqListParams.id)
            self.breakdownLink.query.revisionId = self.boqListParams.id
        },
        async ChangeMinusIndex(){
            const self = this
            self.boqListParams.skip = 0
            self.boqListParams.id = self.revisionList[--this.currentIndex]._id
            self.rawSections = await GetHleNewBoqCreatorSectionsRevisions(self.boqId,self.boqListParams.id)
            self.breakdownLink.query.revisionId = self.boqListParams.id
        }
    },
    mounted : async function(){
        const self = this

        self.boqItem = await GetHighLevelBoq(self.boqId)
        self.hleProject = await GetHighLevelProject(self.hleProjectId)
        self.revisionList  = self.boqItem.revisionList
        self.currentIndex = self.revisionList.length - 1
        const lastRevision = self.boqItem.revisionList[self.revisionList.length - 1]
        self.boqListParams.id = lastRevision._id
        self.boqListParams.boqId = self.boqId
        self.ChangeActiveLink(LinkList.HIGH_LEVEL_ESTIMATES)
        self.boqUrlname = self.boqItem.name  + ' - (' + self.boqItem.currencyId.sign +') '  + self.boqItem.currencyId.shortName  +' '+ self.boqItem.currencyId.name
        self.rawSections = await GetHleNewBoqCreatorSectionsRevisions(self.boqId,lastRevision._id)

        self.breakdownLink.params.id = self.hleProjectId
        self.breakdownLink.params.boqId = self.boqId
        self.breakdownLink.query.revisionId = lastRevision._id

    },
    data(){
        return {
            rawSections : {
                sectionList : [],
                overAllTotal :{}
            },
            hleProjectId : this.$route.params.id,
            hleProject : {},
            boqItem : {
                currencyId : {}
            },
            boqListParams : {},
            ReformatDate : ReformatDate,
            boqId : this.$route.params.boqId,
            isDataReadyToLoad : false,
            revisionList : [],
            boqUrlname : '',
            currentIndex : 0,
            breakdownLink : {name : 'HleBoqItemsHistoryBreakdown',params : {}, query : {}}
        }
    },

}
</script>
